import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {useLocalization} from "../../../../hooks/localization"
import {useRPC} from "../../../../hooks/rpc"
import {RFTestLogType} from "../../../../types/logs"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"

const keyExtractor = (item: RFTestLogType) => item?.device_name
export const RFTestLogsScreen = memo(function RFTestLogsScreen() {
    const [rpc] = useRPC()
    const {t} = useLocalization()
    const [data, setData] = useState<RFTestLogType[]>([])
    const [selectedLog, setSelectedLog] = useState<RFTestLogType>(null)
    const onPressRefresh = useCallback(() => {
        rpc.getDeviceRFSignalReport().then(r => setData(r))
    }, [rpc])

    const buttons = useMemo(
        () => [
            {
                text: t("refresh"),
                className: "blue",
                onClick: onPressRefresh
            }
        ],
        [t, onPressRefresh]
    )

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 2,
                name: t("device_name"),
                key: "device_name"
            },
            {
                length: 2,
                name: "Signal RX",
                key: "signal_rx"
            },
            {
                length: 2,
                name: "Signal TX",
                key: "signal_tx"
            },
            {
                length: 2,
                name: t("total_error"),
                key: "total_error"
            }
        ],
        [t]
    )

    const rfTestLogList = useMemo(() => {
        if (data == null) {
            return []
        }
        return data
    }, [data])

    const displayNameExtractor = useCallback((item: RFTestLogType, column: ColumnModel) => {
        if (column.key === "name") {
            return item
        }
        return item[column.key] || "-"
    }, [])

    useEffect(() => {
        rpc.getDeviceRFSignalReport().then(r => setData(r))
    }, [rpc])

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer
                className="service-edit"
                buttons={buttons}
                backUrl="/settings/logs"
                searchable={false}
            >
                {<SettingsList
                    columns={columns}
                    items={rfTestLogList}
                    keyExtractor={keyExtractor}
                    displayNameExtractor={displayNameExtractor}
                    selectedItem={selectedLog}
                    onItemSelected={setSelectedLog}
    />}
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
